import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgWarningHovered,
  colorBorderInfo,
  warning,
} from 'src/app/themes/primaryThemeDefault'
import { EXCEPTION_STATUS } from '../constants'

export interface IExceptionStatusTag {
  status: string
}

const ExceptionStatusTag: React.FC<IExceptionStatusTag> = (props) => {
  const { status } = props
  const { t } = useTranslation()

  const getConfig = useCallback(
    (status: string) => {
      switch (status.toLowerCase()) {
        case EXCEPTION_STATUS.EXCEPTION:
          return {
            color: warning,
            backgroundColor: colorBgWarningHovered,
            text: t(`QuickExceptionProcessing:status_list.exception`),
          }
        case EXCEPTION_STATUS.PAID:
          return {
            color: colorBorderInfo,
            backgroundColor: '#EDF9FF',
            text: t(`QuickExceptionProcessing:status_list.paid`),
          }
        case EXCEPTION_STATUS.RETURNED:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: t(`QuickExceptionProcessing:status_list.returned`),
          }
        case EXCEPTION_STATUS.PROCESSING:
          return {
            color: '#F8C100',
            backgroundColor: '#FFFAE7',
            text: t(`QuickExceptionProcessing:status_list.processing`),
          }
        default:
          return {
            color: '',
            backgroundColor: '',
            text: '',
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  if (!status) {
    return <div />
  }

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default ExceptionStatusTag
